<template>
    <component :is="layout"></component>
</template>

<script>
import API from '@/api'

export default {
    name: 'app',
    data: () => ({
        invalidSession: false,
        isEmployee: undefined,
        isMainAccount: undefined,
        isManager: undefined,
        currentCorporateClient: undefined,
        logout: false,
        refreshDemands: false,
        refreshContracts: false,
        refreshNotifications: false,
        refreshBrands: false,
        disableClientNavigation: false
    }),
    watch: {
        invalidSession: {
            handler () {
                if (this.invalidSession) {
                    alert('Oops! A sua sessão está inválida é necessário fazer o login novamente.')
                    this.$helpers.clearLocalStorage()
                    this.$router.push('/login').catch(e => {})
                }
            },
            deep: true
        },
        logout: {
            handler () {
                if (this.logout) {
                    this.requestLogout()
                }
            },
            deep: true
        }
    },
    computed: {
        layout () {
            return `${this.$route.meta.layout || 'login'}-layout`
        }
    },
    updated () {
        this.$nextTick(() => {
            this.isEmployee = this.$helpers.checkIsEmployee()
            this.isMainAccount = this.$helpers.checkIsMainAccount()
            this.isManager = this.$helpers.checkIsManager()
            this.currentCorporateClient = this.$helpers.checkCorporateClient()
        })
    },
    created () {
        this.isEmployee = this.$helpers.checkIsEmployee()
        this.isMainAccount = this.$helpers.checkIsMainAccount()
        this.isManager = this.$helpers.checkIsManager()
        localStorage.removeItem('currentCorporateClient')
        this.currentCorporateClient = this.$helpers.checkCorporateClient()
        this.refreshBadgeNotifications = false
        window.getApp = this
    },
    methods: {
        requestLogout () {
            let endpoint = API.EndPoints.logout
            new API(endpoint, {}).request()
            this.invalidSession = false
            this.logout = false
            this.login = false
            this.$helpers.clearLocalStorage()
            this.$router.push('/login').catch(e => {})
        }
    }
}
</script>
